import { Box } from '@mui/material'
import { ReactComponent as Logo } from '../../assets/images/TAG-logo.svg'
import { ReactComponent as LogoText } from '../../assets/images/TAG-logo-text.svg'
import useAuth from '../../hooks/useAuth'

const TAGLogo: React.FC = () => {
  const isAuth = useAuth()
  return (
    <Box sx={{ height: '100%' }}>
      {isAuth ? <Logo height={'100%'} /> : <LogoText height={'100%'} />}
    </Box>
  )
}

export default TAGLogo
